import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { WS_URL } from '../Config/websocketConfig';
import { getAuth } from '../ReduxRequests/Actions/authAction';

let stompClient = null;

const connect = (subscriptions) => {
    stompClient.debug = null
    stompClient.connect({}, frame => {
        subscriptions.forEach(sub => {
            stompClient.subscribe(sub.path, sub.callback);
        })
    });
};

export const disconnect = () => {
    if(stompClient) stompClient.disconnect();
    stompClient = null;
};

export const subscribe = (subscriptions) => {
    disconnect();
    const auth = getAuth();
    const socket = SockJS(WS_URL + `?auth=${auth.token}`);
    stompClient = Stomp.over(socket);
    connect(subscriptions);
};


// WEBPACK FOOTER //
// ./src/Websocket/websocket.ts